import React from 'react'
import Fragment from '../common/fragment'


function FragmentCS(props) {
  return (
    <Fragment pos="sss" {...props}>
      <p>
Las voces subieron como el humo de chimeneas hasta el cielo. En algún lugar se
encontraron con la dirección del viento. Las hojas a medio pudrirse del río.
Dispersión del aire, signos del zodiaco y verbenas entre los juncos. Los peces nadan
en ríos de ultratumba, como Judas del lodo y los desechos.
      </p>
    </Fragment>
  )
}


export default FragmentCS
